import { HPCReport } from '../../models/hpc/hpc_student_report';
import {
  getFirestore,
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where
} from "firebase/firestore";
import { Result } from "../../models/result";

export const getHPCReportForPDF = async (reportId) => {
  try {
     const db = getFirestore();
     const reportDocRef = doc(db, "hpc_pdf_requests", reportId);
     const reportDoc = await getDoc(reportDocRef);
     if (reportDoc.exists()) {
      const reportData = reportDoc.data();
      return new Result({
        value: HPCReport.fromJSON(reportData),
      });
     } else {
      return new Result({
        message: "Report not found",
        code: "NOT_FOUND",
      });
     }
  } catch (error) {
    console.error("Error getting HPC PDF report:", error);
    throw error;
  }
};


export const getHPCReports = async (schoolId) => {
  try {
    const db = getFirestore();
    const reportsCollRef = collection(db, "schools", schoolId, 'hpc_reports');
    const querySnapshot = await getDocs(reportsCollRef);
    const reports = [];
    querySnapshot.forEach((doc) => {
      reports.push(HPCReport.fromJSON({
        ...doc.data(),
        id: doc.id,
      }));
    });
    return new Result({
      value: reports,
    });
  } catch (error) {
    console.error("Error getting HPC reports:", error);
    return new Result({
      message: "Error getting HPC reports: " + error.toString(),
    });
  }
}

export const getStudentHPCReports = async (schoolId, Class, sec, academicYear) =>{
  try {
    const db = getFirestore();
    const reportsCollRef = collection(db, "schools", schoolId, 'hpc_report_students');

    const q = query(reportsCollRef, where("Class", "==", Number(Class)), where("sec", "==", sec), where("academicYear", "==", academicYear));
    
    const querySnapshot = await getDocs(q);
    const reports = [];
    querySnapshot.forEach((doc) => {
      reports.push(HPCReport.fromJSON({
        ...doc.data(),
        id: doc.id,
      }));
    });
    return new Result({
      value: reports,
    });
  } catch (error) {
    console.error("Error getting student HPC reports:", error);
    return new Result({
      message: "Error getting student HPC reports: " + error.toString(),
    });
  }
}
